import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { Toast } from 'primeng/toast';
import { MbHeaderComponent } from '../../features/shared/mb-header/mb-header.component';
import { MenuComponent } from '../../features/shared/menu/menu.component';

@Component({
    selector: 'app-main',
    imports: [
        RouterOutlet,
        InputTextModule,
        ButtonModule,
        MessageModule,
        FormsModule,
        MenuComponent,
        Toast,
        ConfirmDialog,
        ProgressBarModule,
        MbHeaderComponent,
        RouterLink
    ],
    providers: [
        MessageService
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent {

    public isMenuCollapsed: boolean = false;

    constructor() {
        this.isMenuCollapsed = window.innerWidth < 1000;
    }

    toggleMenu() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
    }

}
